// extracted by mini-css-extract-plugin
export default {"subStatus":"style_subStatus__t8h5r","container":"style_container__khGyz","details":"style_details__N3MzB","content":"style_content__KGT94"};